export function computedResidualTime(game, endTime, overtime) {

  //先取实际结束的日期
  if (!overtime || overtime == '')
    overtime = new Date().getTime();
  else {
    overtime = (new Date(overtime)).getTime();
  }
  let currentTime = parseInt(overtime / 1000);
  //获取距离1970年1月1日00:00:00的毫秒数，并转换成秒数，通过parseInt转成整秒数；

  //开始时间转换成整秒数
  let formatTimeS = parseInt(new Date(game).getTime() / 1000);

  //在我这个项目中是三天的过期时间
  let allSeconds = 3 * 24 * 60 * 60;
  if (endTime && endTime != '') {
    allSeconds = parseInt((new Date(endTime)).getTime() / 1000) - formatTimeS;
  }
  let residualTime = allSeconds - (currentTime - formatTimeS);
  //这是剩余的所有秒数（规定时间过期时间－（本机距离1970年1月1日00:00:00的秒数－后台的创建时间））

  let day = parseInt(residualTime / (24 * 3600)); //剩余天数
  let hour = parseInt((residualTime) % (24 * 3600) / 3600); //剩余小时
  let minute = parseInt((residualTime) % 3600 / 60); //剩余分钟
  let second = parseInt((residualTime) % 60);  //剩余秒数
  var showcolor = day == 0 ? '#ffa800' : '#00CCCD';
  if (day > 0 || hour > 0 || minute > 0 || second > 0) {
    return `<span style="float:right;padding-right: 10px;color:${showcolor}">剩：${day}天${setTimeZero(hour)}小时${setTimeZero(minute)}分</span>`;//${second}秒
  } else {
    //Math.abs()绝对值
    return `<span style="float:right;padding-right: 10px;color: red"><b>超：${Math.abs(day)}天${setTimeZero(Math.abs(hour))}小时${setTimeZero(Math.abs(minute))}分</b></span>`;//${Math.abs(second)}秒
  }
};

//将数字转换为大写字符串
export function convertToBigMoney(n) {
  if (isNaN(n)) {//不是数字
    return "";
  }
  //小数点后单位
  var fraction = ['角', '分'];
  var digit = [
    '零', '壹', '贰', '叁', '肆',
    '伍', '陆', '柒', '捌', '玖'
  ];
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  //判断正负数
  var head = n < 0 ? '负' : '';
  //取绝对值
  n = Math.abs(n);
  var s = '';
  //取出小数部分大写内容
  for (var i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);
  //取出正数部分大写内容
  for (var i = 0; i < unit[0].length && n > 0; i++) {
    //元，万，亿位上的大写数字
    var p = '';
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      // 个十百千位上的大写数字
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整');
}

export function getRemark(remark,excloudtype,showtype) {
  if (remark) {
    try {
      let temp = JSON.parse(remark.replace(new RegExp("\n", "gm"), ""))
      let s = "", s_tuihuotype = "", s_tuihuoreason = "", tuihuodate = ""


      for (let i in temp) {
        var item = temp[i];
        if (excloudtype && item.type){//排除显示的备注信息
          if (excloudtype == item.type) {
            continue;
          }
        } else if (showtype&& item.type) {
          if (showtype == item.type) {
            return item.msg;
          }else{
            continue;
          }
        }

        if (item.msg && item.msg != '') {
          if (item.type == '退货类型') {
            s_tuihuotype = item.msg == 'null' || !item.msg ? "" : item.msg
            tuihuodate = "（" + item.uname + " " + formatDate(item.date) + "）"
          } else if (item.type == '退货原因') {
            s_tuihuoreason = item.msg == 'null' || !item.msg ? "" : item.msg
            tuihuodate = "（" + item.uname + " " + formatDate(item.date) + "）"
          } else if (item.type == '验光配镜单号' && item.msg) {
            s += "验光配镜单号：" + item.msg + "<br/>"
          } else if (item.type != '眼镜已到') {
            s += (item.msg == 'null' || !item.msg ? "" : item.msg) + "（" + item.uname + " " + formatDate(item.date) + "）<br/>"
          }
        }
      }
      let temp2 = ""
      if (s_tuihuoreason) {
        temp2 = s_tuihuoreason
      }
      if (s_tuihuotype) {
        temp2 = s_tuihuotype + "&nbsp;" + temp2
      }
      if (temp2) {
        s = '【退货】' + temp2 + tuihuodate + "<br/>" + s
      }
      return s
    } catch (ex) {
      //console.log(ex)
    }
  }
  return ""
}
export function getKFRemark(remark) {
  if (remark) {
    try {
      let temp = JSON.parse(remark.replace(new RegExp("\n", "gm"), ""))
      let s = "", s_kefutype = "", kefudate = ""
      temp.forEach(item => {
        if (item.msg && item.msg != '') {
          if (item.type == '客服留言') {
            s_kefutype = item.msg == 'null' || !item.msg ? "" : item.msg
            kefudate = "（" + item.uname + " " + formatDate(item.date) + "）"
          }
        }
      })
      let temp2 = ""
      if (s_kefutype) {
        temp2 = s_kefutype + "&nbsp;" + temp2
      }
      if (temp2) {
        s =  temp2 + kefudate + "<br/>" + s
      }
      return s
    } catch (ex) {
      console.log(ex)
    }
  }
  return ""
}
//获取客户留言, 打印时使用，不显示客服留言
export function getKHRemark(remark) {
  if (remark) {
    try {
      let temp = JSON.parse(remark.replace(new RegExp("\n", "gm"), ""))
      let s = "", s_tuihuotype = "", s_tuihuoreason = "", tuihuodate = ""
      temp.forEach(item => {
        if (item.type == '退货类型') {
          s_tuihuotype = item.msg == 'null' || !item.msg ? "" : item.msg
          tuihuodate = "（" + item.uname + " " + formatDate(item.date) + "）"
        } else if (item.type == '退货原因') {
          s_tuihuoreason = item.msg == 'null' || !item.msg ? "" : item.msg
          tuihuodate = "（" + item.uname + " " + formatDate(item.date) + "）"
        } else if (item.type == '验光配镜单号' && item.msg) {
          s += "验光配镜单号：" + item.msg + "<br/>";
        } else if (item.msg && item.type != '客服留言') {
          s += (item.msg == 'null' || !item.msg ? "" : item.msg) + "（" + item.uname + " " + formatDate(item.date) + "）<br/>";
        }
      })
      let temp2 = ""
      if (s_tuihuoreason) {
        temp2 = s_tuihuoreason
      }
      if (s_tuihuotype) {
        temp2 = s_tuihuotype + "&nbsp;" + temp2
      }
      if (temp2) {
        s = '【退货】' + temp2 + tuihuodate + "<br/>" + s
      }
      return s
    } catch (ex) {
    }
  }
  return ""
}

export function getKHRemarkSimp(remark) {
  if (remark) {
    try {
      let temp = JSON.parse(remark.replace(new RegExp("\n", "gm"), ""))
      let s = "";
      temp.forEach(item => {
        if (item.msg && item.type == '客户留言') {
          s += (item.msg == 'null' || !item.msg ? "" : item.msg);
        }
      })
      return s
    } catch (ex) {
    }
  }
  return ""
}

//镜架导入
export function loadSpecFrame(data,categorycode,categoryname,defaultprice) {
  let arr = []
  if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
    for (let j in data) {

      let obj = {}
      var model = data[j]['型号'];
      if (model == null)
        model = "";
      model = model.replace(/ /g, "").toUpperCase().replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      var color = (data[j]['规格'] ? data[j]['规格'] : (data[j]['色号'] ? data[j]['色号'] : '')).toUpperCase().replace(/ /g, "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");;

      if (model == '') {
        this.$message({
          message: '型号必填！',
          type: 'warning'
        })
        return [];
      }
      obj.goodsframe = '[{"model":"' + model + '","color":"' + color + '"}]'
      obj.minnumber = data[j]['数量'] ? parseInt(data[j]['数量']) : 0

      var exist = false
      for (let m in arr) {
        if (arr[m].goodsframe == obj.goodsframe) {//重复商品、数量相加
          exist = true
          arr[m].minnumber += obj.minnumber;
          break;
        }
      }
      if (exist) {
        continue;
      }

      obj.seedcode = '';// data[j]['商品代码'] ? data[j]['商品代码'] : ''
      obj.seedname = (data[j]['商品名称'] ? data[j]['商品名称'] : '').replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      obj.categorycode = categorycode
      obj.filltemplate = 80
      obj.seedunit = '副'
      obj.pricetype = 1
      obj.bom = 0
      obj.enabled = 1
      obj.advertisement = ''
      obj.sortnum = 0
      obj.nostock = -1;//data[j]['是否备货'] != null && data[j]['是否备货'] == '备货' ? 1 :
      obj.noscancode = -1;//data[j]['是否扫唯一码出入库'] != null && data[j]['是否扫唯一码出入库'] == '是' ? 1 :
      if (data[j]['产地']) {
        obj.place = data[j]['产地'];
      }
      if (data[j]['标签']) {
        obj.bigseedunit = data[j]['标签'];
      }

      var temp1 = [], temp2 = []
      // if (data[j]['类别']) {
      //   temp1.push({name: '类别', item: data[j]['类别']});
      // }
      if (data[j]['镜架颜色']) {
        temp1.push({name: '镜架颜色', item: data[j]['镜架颜色']});
      }
      if (data[j]['镜片颜色']) {
        temp1.push({name: '镜片颜色', item: data[j]['镜片颜色']});
      }
      if (data[j]['供应商产品编码']) {
        obj.goodserpserial=data[j]['供应商产品编码'];
      }
      if (data[j]['材质']) {
        obj.material=data[j]['材质'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }
      if (data[j]['框型']) {
        obj.boxtype=data[j]['框型'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }
      if (data[j]['对标品牌']) {
        obj.benchbrand=data[j]['对标品牌'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }
      if (data[j]['风格']) {
        obj.style=data[j]['风格'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }
      if (data[j]['性别']) {
        obj.gender=data[j]['性别'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }
      if (data[j]['尺寸']) {
        obj.fsize=data[j]['尺寸'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }
      if (data[j]['备注']) {
        obj.notes=data[j]['备注'].replace(new RegExp(" ", "gm"), "").replace(new RegExp("\n", "gm"), "").replace(new RegExp("\t", "gm"), "").replace(new RegExp("\r", "gm"), "");
      }

      // if (data[j]['镜宽']) {
      //   temp1.push({name: '镜宽', item: data[j]['镜宽']});
      // }
      // if (data[j]['梁宽']) {
      //   temp1.push({name: '梁宽', item: data[j]['梁宽']});
      // }
      // if (data[j]['镜高']) {
      //   temp1.push({name: '镜高', item: data[j]['镜高']});
      // }
      // if (data[j]['镜腿长度']) {
      //   temp1.push({name: '镜腿长度', item: data[j]['镜腿长度']});
      // }
      // if (data[j]['特性']) {
      //   temp1.push({name: '特性', item: data[j]['特性']});
      // }
      // if (data[j]['品种']) {
      //   temp1.push({name: '品种', item: data[j]['品种']});
      // }

      obj.relatedcategoryname = data[j]['供应商'] ? data[j]['供应商'] : '';
      obj.costprice = data[j]['采购成本价'] ? parseFloat(data[j]['采购成本价']) : 0;
      obj.refsellprice = data[j]['零售价'] ? parseFloat(data[j]['零售价']) : 0;
      obj.memberprice = data[j]['会员价']&&!isNaN(parseFloat(data[j]['会员价']))&&parseFloat(data[j]['会员价'])>=0 ? parseFloat(data[j]['会员价']) : null;
      if (obj.refsellprice <= 0 && defaultprice && defaultprice > 0) {
        obj.refsellprice = defaultprice;//默认价格
      }

      obj.queryproperty = temp1.length > 0 ? JSON.stringify(temp1) : "";
      obj.formproperty = temp2.length > 0 ? JSON.stringify(temp2) : "";

      arr.push(obj)
    }
  }
  return arr;
}

export function pickerShortCuts() {
  return [{
    text: '近一周',
    onClick(picker) {
      const end = picker.value ? new Date(picker.value[1]) : new Date();
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '近一个月',
    onClick(picker) {
      const end = picker.value ? new Date(picker.value[1]) : new Date();
      const start = picker.value ? new Date(picker.value[1]) : new Date();
      start.setMonth(start.getMonth() - 1);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '近三个月',
    onClick(picker) {
      const end = picker.value ? new Date(picker.value[1]) : new Date();
      const start = picker.value ? new Date(picker.value[1]) : new Date();
      start.setMonth(start.getMonth() - 3);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '近半年',
    onClick(picker) {
      const end = picker.value ? new Date(picker.value[1]) : new Date();
      const start = picker.value ? new Date(picker.value[1]) : new Date();
      start.setMonth(start.getMonth() - 6);
      picker.$emit('pick', [start, end]);
    }
  },
    //   {
    //   text: '近一年',
    //   onClick(picker) {
    //     const end =  picker.value ? new Date(picker.value[1]) : new Date();
    //     const start = picker.value ? new Date(picker.value[1]) : new Date();
    //     start.setMonth(start.getMonth() - 12);
    //     picker.$emit('pick', [start, end]);
    //   }
    // },
    {
      text: '全年',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 0, 1), new Date(end.getFullYear(), 11, 31)]);
      }
    }, {
      text: '上半年',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 0, 1), new Date(end.getFullYear(), 5, 30)]);
      }
    }, {
      text: '下半年',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 6, 1), new Date(end.getFullYear(), 11, 31)]);
      }
    },
    {
      text: '一季度',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 0, 1), new Date(end.getFullYear(), 2, 31)]);
      }
    }, {
      text: '二季度',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 3, 1), new Date(end.getFullYear(), 5, 30)]);
      }
    }, {
      text: '三季度',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 6, 1), new Date(end.getFullYear(), 8, 30)]);
      }
    }, {
      text: '四季度',
      onClick(picker) {
        const end = picker.value ? new Date(picker.value[1]) : new Date();
        picker.$emit('pick', [new Date(end.getFullYear(), 9, 1), new Date(end.getFullYear(), 11, 31)]);
      }
    }]
}

//金额转换
export function ConvertMoney(money, len) {
  if (money == '')
    return money;

  var s = money; //获取小数型数据
  s += "";
  if (s.indexOf(".") == -1) {
    s += "."; //如果没有小数点，在后面补个小数点和0
    for (var i = 0; i < len; i++) {
      s += "0";
    }
  } else {
    for (var i = s.split('.')[1].length; i < len; i++) {
      s += "0";
    }
  }

  if (/\.\d$/.test(s))
    s += "0"; //正则判断

  while (/\d{4}(\.|,)/.test(s)) //符合条件则进行替换
  {
    s = s.replace(/(\d)(\d{3}(\.|,))/, "$1,$2"); //每隔3位添加一个
  }

  if (s.indexOf('.') == s.length - 1) {
    s = s.substring(0, s.length - 1);
  }
  return s;
}

function setTimeZero(value) {
  return value > 9 ? value : '0' + value;
}

// function formatDate(date){
//   var myDate = new Date(date);
//   return (setTimeZero(myDate.getMonth()+1))+'-'+setTimeZero(myDate.getDate())+" "+setTimeZero(myDate.getHours())+":"+setTimeZero(myDate.getMinutes());
// }
function formatDate(date) {
  if(!date)
    return '';
  var myDate = new Date(date);
  if (date.length > 10) {
    return (setTimeZero(myDate.getMonth() + 1)) + '-' + setTimeZero(myDate.getDate()) + ' ' + setTimeZero(myDate.getHours()) + ':' + setTimeZero(myDate.getMinutes());
  } else {
    return (setTimeZero(myDate.getMonth() + 1)) + '-' + setTimeZero(myDate.getDate());

  }
}



// WEBPACK FOOTER //
// ./src/plugin/ordercommon.js